__webpack_require__.p = "https://assets-01.periodica.press/d1558b0-26799900015/";